import axios from "axios";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "").replace(/\/+$/, "");

async function request(method, path, data) {
  try {
    const response = await axios({ method, url: `${API_BASE}${path}`, data, timeout: 90000, validateStatus: () => true });
    if (response.status >= 400 || response.data?.ok === false) {
      const error = new Error(response.data?.message || `Não foi possível concluir a solicitação (HTTP ${response.status}).`);
      error.status = response.status;
      error.code = response.data?.errorCode || "SUPER_JHONNY_REQUEST_FAILED";
      error.retryAfterSeconds = Number(response.data?.retryAfterSeconds || 0);
      throw error;
    }
    return { data: response.data?.data ?? response.data, message: response.data?.message || "", status: response.status };
  } catch (error) {
    if (error?.code === "ECONNABORTED") throw new Error("O servidor demorou demais para responder. Tente novamente em alguns instantes.");
    if (error?.response) throw new Error(error.response.data?.message || `Não foi possível concluir a solicitação (HTTP ${error.response.status}).`);
    if (error?.status || error?.code === "SUPER_JHONNY_REQUEST_FAILED") throw error;
    throw new Error("Não foi possível comunicar com o backend do sistema.");
  }
}

export const fetchSuperJhonny = () => request("get", "/api/super-jhonny");
export const connectSuperJhonny = (payload) => request("post", "/api/super-jhonny/connections", payload);
export const syncSuperJhonny = (slot) => request("post", "/api/super-jhonny/sync", { slot });
export const removeSuperJhonnyConnection = (slot, retention) => request("delete", `/api/super-jhonny/connections/${encodeURIComponent(slot)}`, { retention });
export const saveSuperJhonnyCase = (clientKey, payload) => request("post", `/api/super-jhonny/supervisor/clients/${encodeURIComponent(clientKey)}/actions`, payload);

export async function downloadSuperJhonnyRuns() {
  const response = await axios.get(`${API_BASE}/api/super-jhonny/sync-runs.csv`, { responseType: "blob", timeout: 60000 });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `super-jhonny-sincronizacoes-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
